export default "__VITE_ASSET__DNnPHvVg__"